(ns bec-cljs-common.re-frame
  (:require [re-frame.core :as rf]
            [day8.re-frame.async-flow-fx]
            [taoensso.timbre :as log]
            [cljs.core.async :as async]
            [bec-data-format.core :as bec-df]
            [bec-cljs-common.config :as bec-config]
            [bec-cljs-common.networking :as bec-net]))

(rf/reg-event-fx ::xhrio-result
  (fn [cofx [_ {:keys [req event-key result-fn result-type result-ch] :as args} result]]
    (when (or (= :failure result-type)
              (:debug? req))
      (log/log (case result-type :success :debug, :failure :warn) :xhrio-result event-key result-type result))
    (let [cofx (update-in cofx [:db :loading] dissoc event-key)
          res (try
                (result-fn cofx result)
                (catch :default ex
                  (log/fatal ex "DEV: You should probably catch exceptions in your :on-success and :on-failure callbacks!")
                  cofx))] ;; We pass cofx on as res; without the :loading entry.
      (when result-ch (async/offer! result-ch {:req req, :event-key event-key, :result-type result-type, :result result}))
      {:db (or (:db res) (:db cofx))
       :fx (or (:fx res) [])})))


;; Basic XHR handling; inlines :on-success / :on-failure via dispatched callbacks so we don't have to setup global event handlers just for this stuff.
;; TODO: We should setup checks for :ex-normal? (normal user exceptions) here -- matching the setup mentioned in route.clj (GS). These are not to be regarded as fatal log events.
(rf/reg-event-fx ::xhrio
  ;; In addition to opts suitable for :http-xhrio, `req` can take:
  ;;   - `:debug?` if true, extra log events will be generated; even for successful requests.
  ;;   - `:result-ch` if given an c.c.async/chan, a value like this will be passed to it: {:result-type :success | :failure, :result ..}.
  (fn [cofx [_ req]]
    (let [req-id (random-uuid)
          timeout (or (:timeout req) 15000)
          event-key (or (:event-key req) (select-keys req [:method :uri])) ;; TODO: I should cut away any query string for the default value here -- but tbh even this isn't enough because people might pass params as a part of the normal URL e.g. "../set-remaining-minutes/42".
          on-success (or (:on-success req) (fn [cofx result] cofx))
          on-failure (or (:on-failure req) (fn [cofx result] cofx))
          result-ch (:result-ch req)]
      (when (:debug? req)
        (log/debug :xhrio (dissoc req :result-ch)))
      (if (get-in cofx [:db :loading event-key])
        (log/warn (ex-info "Already in loading state; not doing same XHR again."
                           {:event-key event-key, :request (select-keys req [:method :uri :params])}))
        (do
          (async/go ;; Additional timeout handling. Needed because it seems neither :on-success or :on-failure gets called in certain situations. E.g. when I resume my laptop at "strategical" (unlucky)  moments! NOTE: It might seem reasonable to just use a timestamp instead of `req-id`, but view might be observing the :loading entry and decided to disable (CSS) the component/widget/link/whatever. ;; TODO: Seems we should be using :on-request for this stuff.
            (async/<! (async/timeout (+ timeout 3000)))
            (rf/dispatch [:run (fn [db]
                                 (if (= req-id (get-in db [:loading event-key]))
                                   (do
                                     (log/warn "Stuck ::xhrio request? Resetting so we can continue!")
                                     (rf/dispatch [::xhrio-result {:req req, :event-key event-key, :result-fn on-failure
                                                                   :result-type :failure, :result-ch result-ch}
                                                   ::timeout-reset])
                                     db)
                                   db))]))
          (-> (assoc-in cofx [:db :loading event-key] req-id)
              (assoc :fx [[:http-xhrio
                           (merge {:params nil, :timeout timeout
                                   :format (bec-df/cljs-ajax-request-format)
                                   :response-format (bec-df/cljs-ajax-response-format)
                                   :on-success [::xhrio-result {:req req, :event-key event-key, :result-fn on-success
                                                                :result-type :success, :result-ch result-ch}]
                                   :on-failure [::xhrio-result {:req req, :event-key event-key, :result-fn on-failure
                                                                :result-type :failure, :result-ch result-ch}]}
                                  (-> (update req :params #(if (fn? %) (% (:db cofx)) %))
                                      (dissoc :event-key :on-success :on-failure :result-ch :debug?))
                                  {:headers (merge (:headers req)
                                                   {:bec-app-category bec-config/app-category
                                                    :bec-app-type bec-config/app-type
                                                    :bec-device-id bec-config/device-id
                                                    :bec-session-id bec-config/session-id
                                                    :bec-viewport-id bec-config/viewport-id
                                                    :bec-message-counter (-> cofx :db ::bec-net/message-counter)})})]])
              (select-keys [:db :fx])))))))


(defn log-result "Pass this for :on-success and/or :on-failure for the ::xhrio event."
  [cofx result] ;; TODO: Not very interesting I suppose.
  (log/info ::xhrio result)
  cofx)


(letfn [(xhrio-async-result-test [event-key-goal result-type-goal]
          (fn [[event & args]]
            (if (= ::xhrio-result event)
              (let [{:keys [event-key result-type] :as xhrio-result-args} (first args)]
                #_(println {:event-key event-key, :event-key-goal event-key-goal
                            :result-type result-type, :result-type-goal result-type-goal}) ;; aoeu
                (and (= event-key event-key-goal)
                     (= result-type result-type-goal)))
              false)))]

  (defn xhrio-async-success? "Meant to be passed as an arg for `:events` in context of re-frame-async-flow-fx."
    [event-key]
    (xhrio-async-result-test event-key :success))


  (defn xhrio-async-failure? "Meant to be passed as an arg for `:events` in context of re-frame-async-flow-fx."
    [event-key]
    (xhrio-async-result-test event-key :failure)))


(defn url-cache-bust "Cache-bust coordinator for client-side URLs. See darts-control-client.widgets.player/player-circle for example use.
  The supporting Fn for this is found in bec-clj-common.views/url-cache-bust."
  [url]
  (if-let [cache-bust (get (-> @re-frame.db/app-db ;; TODO: Hmm, perhaps this should be a sub?
                               :bec-clj-common
                               :views
                               :shared-ephemeral
                               :url-cache-bust)
                           url)]
    (let [[url query-str] (clojure.string/split url "?")]
      (str url "?_bec_cache_bust=" cache-bust (when query-str (str "&" query-str))))
    url))
